import Controller from '@ember/controller';

export default class CommunicationsMessageLogNewController extends Controller {
  queryParams = ['from'];
  from: string = '';

  get showBackButton(): boolean {
    return this.from === 'message-log';
  }
}
